import React from 'react';
import { Body, Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { SharedHero } from '@hover/shared-components';
import {
  ContractorsLogoList,
  HeaderDescription,
  Layout,
  NewsLetterBar,
  ReadyToSeePossibilities,
  UtilityMenuBanner,
} from '../../v2/components/common';

import {
  ClaimsEstimation,
  CustomerQuote,
  Measurements,
  Resolution,
} from '../../v2/components/insurance';
import { URLS } from '../../v2/constants';
import { usePageViewTracking } from '../../utils/trackPageView';

const Insurance: React.FC = () => {
  usePageViewTracking('insurance');

  return (
    <Layout
      title="Exterior Home Improvement Software For Insurance"
      description="We help you respond to claims faster. Remote damage surveys, accurate measurements, and seamless integration to your existing tools make it easier to support your customers as they get their homes back to feeling like homes again."
      buttonType="SCHEDULE_A_DEMO"
      bannerElement={<UtilityMenuBanner />}
    >
      <SharedHero
        haveContentChildren
        heading="Get things back to normal faster."
        body="Make it faster and easier for homeowners to file a claim and get it approved."
        chatWithUsLink={URLS.insurance.chatWithUs}
        desktopImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            alt="insurance hero"
            src="../../v2/assets/images/insurance_hero.png"
          />
        }
        mobileAndTabletImage={
          <StaticImage
            loading="eager"
            placeholder="blurred"
            alt="insurance hero"
            src="../../v2/assets/images/insurance_hero_tablet.png"
          />
        }
        page="insurance"
      />
      <Box w="100%" mb={700}>
        <Body mx="auto" fontWeight={600}>
          Insurance partners that prefer HOVER
        </Body>
      </Box>
      <ContractorsLogoList mb={{ base: '80px', tablet: 1100 }} />
      <HeaderDescription
        mb={{ base: '72px', desktop: 1100 }}
        heading="HOVER not only makes home restoration projects simpler, but a lot less
      stressful"
        body="We help you respond to claims faster. Remote damage surveys, accurate
      measurements, and seamless integration to your existing tools make it
      easier to support your customers as they get their homes back to feeling
      like homes again."
      />
      <Measurements />
      <ClaimsEstimation />
      <Resolution />
      <ReadyToSeePossibilities
        body="Whether you’re an insurance partner, a small carrier, a national team,
            or somewhere in between, we can help."
        testId="insurance-page-main"
      />
      <CustomerQuote />
      <NewsLetterBar showForm showViewJobs={false} />
    </Layout>
  );
};

export default Insurance;
